import React from "react";
import PropTypes from "prop-types";

import {
	ContentWrapper,
	PageColumn,
	PageContainer,
	PageWrapper,
	RTEWrapper,
	SplitPageWrapper,
} from "BaseComponents/Wrappers";
import MapBlocksToComponents from "Helpers/BlockHelper";
import {H1, Ingress} from "BaseComponents/Text/";
import SideMenu from "Components/Sidemenu/SideMenu";
import {StandardImage} from "Components/StandardImage";
import styled from "styled-components";
import {EmployeeBlock} from "Blocks/EmployeeBlock";
import {EmployeeListBlock} from "Blocks";

let EmployeePage = ({
	Heading,
	Preamble,
	Text,
	menu,
	Image,
	ImageText,
	LastUpdatedText,
	LastUpdated,
	ElementArea,
	theme,
	Contacts,
}) => {
	let hasChildren = menu.Children.length > 0;
	const ElementAreaWrapper = styled.div`
		background-color: ${({ theme }) => theme.colors.lightgrey};
	`;
	return (
		<PageWrapper theme={theme}>
			<PageContainer>
				<SplitPageWrapper>
					<PageColumn hasChildren={hasChildren}>
						<H1 margin="0 0 30px 0">{Heading}</H1>
						{Preamble && (
							<Ingress
								margin="0 0 30px 0"
								marginSmall="0 0 15px 0"
								dangerouslySetInnerHTML={{
									__html: Preamble,
								}}
							></Ingress>
						)}
						<ContentWrapper>
							{Image && <StandardImage src={Image} byline={ImageText} />}
							{Text && (
								<RTEWrapper
									dangerouslySetInnerHTML={{
										__html: Text,
									}}
								></RTEWrapper>
							)}
						</ContentWrapper>

						{Contacts.map((block, key) => (
							<EmployeeListBlock {...block} key={key} />
						))}
					</PageColumn>
					{hasChildren && (
						<PageColumn>
							<SideMenu {...menu} />
						</PageColumn>
					)}
				</SplitPageWrapper>
			</PageContainer>
			<ElementAreaWrapper>
				<EmployeeBlock />
				{ElementArea.length > 0 && MapBlocksToComponents(ElementArea)}
			</ElementAreaWrapper>
		</PageWrapper>
	);
};

EmployeePage.propTypes = {
	Heading: PropTypes.string,
	Text: propTypes.string,
};

export default EmployeePage;
